import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lc-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {

  @Output() onClose: EventEmitter<boolean> = new EventEmitter();
  @Input() customclass: string;

  constructor() { }

  ngOnInit() {
  }

  close_popup(){
    // this.body.style.overflow = 'auto';
    this.onClose.emit(true);
    }

}



// WEBPACK FOOTER //
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/popup/popup.component.ts